/**
 * @file Template.js
 */
'use strict';

/**
 * @classname Template
 */

export default class Template {


    /**
     * 子育てプチ情報記事作成
     *
     * @memberof Template
     * @return {string} - 部署
     */
    static createBlog(item) {
        const date = item.start_at.substr(0, 10).replace(/-/g,  '/');
        const categoryType = item.category_type;
        let category = '';
        for(let i = 0; i < categoryType.length; i ++){
            if(categoryType[i] === 1){
                category += '<span class="badge badge--outdoor">お出かけ</span>';
            }else if(categoryType[i] === 2){
                category += '<span class="badge badge--preschool">子供を預ける</span>';
            }else if(categoryType[i] === 3){
                category += '<span class="badge badge--support">支援・サポート</span>';
            }else if(categoryType[i] === 4){
                category += '<span class="badge badge--health">検診・健康</span>';
            }else if(categoryType[i] === 5){
                category += '<span class="badge badge--sick">病気・怪我</span>';
            }else if(categoryType[i] === 6){
                category += '<span class="badge badge--accident">事故</span>';
            }else if(categoryType[i] === 7){
                category += '<span class="badge badge--consultation">相談</span>';
            }else if(categoryType[i] === 8){
                category += '<span class="badge badge--meal">食事</span>';
            }else if(categoryType[i] === 9){
                category += '<span class="badge badge--other">すべて</span>';
            }else if(categoryType[i] === 10){
                category += '<span class="badge badge--other">未分類</span>';
            }
        }
        return `
<li class="list__item">
    <div data-article-id="${item.id}" class="card card--report card--childcare">
        <div class="card__header">
            <img src="${item.image_url}" alt="${item.title}" class="image">
        </div>
        <div class="card__body">
            <div class="block block--badge">
                <p class="text text--report-date">${date}</p>
                <span class="badge badge--blog">子育てブログ</span>
                ${category}
            </div>
            <a href="${item.show}" class="anchor anchor--main">${item.title}</a>
            <p class="text text--right">
                <a href="${item.show}" class="anchor">もっと見る<i class="fas fa-chevron-right ml5"></i></a>
            </p>
        </div>
    </div>
</li>
`;
    };


    /**
     * 体験レポート記事作成
     *
     * @memberof Template
     * @return {string} - 部署
     */
    static createMagazine(item) {
        const date = item.start_at.substr(0, 10).replace(/-/g,  '/');
        let area = '';
        if(item.city_id && item.city_id !== ''){
            area = `<span class="badge badge--area">${item.city_id}</span>`;
        }
        const categoryType = item.category_type;
        let category = '';
        for(let i = 0; i < categoryType.length; i ++){
            if(categoryType[i] === 1){
                category = '<span class="badge badge--type">地域団体活動</span>';
            }else if(categoryType[i] === 2){
                category = '<span class="badge badge--type">自宅体験</span>';
            }else if(categoryType[i] === 3){
                category = '<span class="badge badge--type">子育てサロン</span>';
            }else if(categoryType[i] === 4){
                category = '<span class="badge badge--type">博物館</span>';
            }else if(categoryType[i] === 5){
                category = '<span class="badge badge--type">体験施設</span>';
            }else if(categoryType[i] === 6){
                category = '<span class="badge badge--type">子育て広場</span>';
            }else if(categoryType[i] === 7){
                category = '<span class="badge badge--type">遊び場</span>';
            }else if(categoryType[i] === 8){
                category = '<span class="badge badge--type">その他</span>';
            }else if(categoryType[i] === 9){
                category = '<span class="badge badge--type">地域サポート</span>';
            }
        }
        return `
<li class="list__item">
    <div data-article-id="${item.id}" class="card card--report card--experience">
        <div class="card__header">
            <img src="${item.image_url}" alt="${item.title}" class="image">
        </div>
        <div class="card__body">
            <div class="block block--badge">
                ${category}
                ${area}
            </div>
            <a href="${item.show}" class="anchor anchor--main">${item.title}</a>
            <p class="text text--right">
                <a href="${item.show}" class="anchor">もっと見る<i class="fas fa-chevron-right ml5"></i></a>
            </p>
        </div>
    </div>
</li>
`;
    };
}
